import { render, staticRenderFns } from "./btn_add_product_reason.vue?vue&type=template&id=5822eb75"
import script from "./btn_add_product_reason.vue?vue&type=script&lang=js"
export * from "./btn_add_product_reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports